/** Personal shortcuts belong to an authenticated account, including on a shared browser. */
export function lensReaderStorageKey(base: string, email?: string | null): string | null {
  const reader = email?.trim().toLowerCase();
  return reader ? `${base}:${reader}` : null;
}
